import ButtonsStep from "./buttons-step";

import image1 from '../assets/500k.svg';
import image1hover from '../assets/500k-hover.svg';
import image2 from '../assets/500k-1m.svg';
import image2hover from '../assets/500k-1m-hover.svg';
import image3 from '../assets/1m-5m.svg';
import image3hover from '../assets/1m-5m-hover.svg';
import image4 from '../assets/5m.svg';
import image4hover from '../assets/5m-hover.svg';

function Step4() {
    const stepTitle = `What is your annual revenue?`;

    const stepElements = [
        {
            "text": "Under $500K",
            "image": image1,
            "imageHover": image1hover,
            "value": 1,
        },
        {
            "text": "$500K - $1M",
            "image": image2,
            "imageHover": image2hover,
            "value": 2,
        },
        {
            "text": "$1M - $5M",
            "image": image3,
            "imageHover": image3hover,
            "value": 3,
        },
        {
            "text": "$5M+",
            "image": image4,
            "imageHover": image4hover,
            "value": 4,
        },
    ];

    return (
        <>
            <h3 className='h2 fw-normal mb-5 text-center'>{stepTitle}</h3>
            <ButtonsStep stepElements={stepElements} stepTitle={stepTitle}></ButtonsStep>
        </>
    );
}

export default Step4;